
import { useStore } from '@/store'
import { defineComponent } from 'vue'
import { computed } from 'vue'
import nameSettings from '@/settings/name-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import NameColorForm from '@/components/Abstract/NameColorForm.vue'
import NameCharForm from '@/components/Abstract/NameCharForm.vue'
import Analytics from '@/singletons/analytics'
import FormTab from '@/components/Abstract/FormTab.vue'

export default defineComponent({
  name: 'FormName',
  components: {
    FormTab,
    FormOption,
    NameColorForm,
    NameCharForm
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const options = computed(() => nameSettings.nameitoColors)
    const configNonameId = computed(() => store.getters.configNonameId)

    const onNoClick = (_) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NONAME, nameSettings.noName.id)
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAEMTHREAD, null)
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAMECHAR, null)
      Analytics.instance.sendNameYesNo(false)
    }

    const onYesClick = (_) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NONAME, nameSettings.yesName.id)
    }

    return {
      nameSettings,
      configNonameId,
      onNoClick,
      onYesClick,
      options,
    }
  }
})
